import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackEvent } from "./analytics";

/**
 * Fires a GA4 `page_view` on every react-router navigation. Firebase Analytics
 * only auto-collects the initial load, so without this an SPA records almost no
 * page views. Render once inside <BrowserRouter>.
 *
 * NOTE: if you leave GA4 Enhanced Measurement's "page changes based on browser
 * history events" ON for the data stream, you'll double-count — turn that off
 * and let this be the single source of page_view.
 */
export function AnalyticsPageViews(): null {
  const location = useLocation();

  useEffect(() => {
    trackEvent("page_view", {
      page_path: `${location.pathname}${location.search}`,
      page_location: window.location.href,
      page_title: document.title,
    });
  }, [location.pathname, location.search]);

  return null;
}
